module.exports = __webpack_public_path__ + "static/media/Videos 1.364efab0.svg";